import { render } from "./PartnerIronhorse.vue?vue&type=template&id=b40f8006"
import script from "./PartnerIronhorse.vue?vue&type=script&lang=js"
export * from "./PartnerIronhorse.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__